import { render, staticRenderFns } from "./ModalClearEntitlements.vue?vue&type=template&id=5b5853e5"
import script from "./ModalClearEntitlements.vue?vue&type=script&lang=js"
export * from "./ModalClearEntitlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports